// It will be updated during order sumarry implementation

export default {
    parts: [
        'accordionItem',
        'accordionButton',
        'headerRow',
        'headerTitleRow',
        'headerAmount',
        'accordionPanel',
        'detailsStack',
        'detailsRow',
        'rowText',
        'shippingLabelWrap',
        'shippingLabel',
        'totalRow',
        'totalText',
        'taxShippingAtCheckout'
    ],
    baseStyle: {
        accordionItem: {
            border: 'none',
            borderTop: '1px solid',
            borderColor: 'webTheme.strokeTertiary',
            m: '0 -16px',
            p: '0 16px'
        },
        accordionButton: {
            fontSize: 'sm',
            fontWeight: '700',
            textDecoration: 'none',
            textTransform: 'uppercase',
            p: '0',
            mb: 3,
            mt: 4,
            display: 'block',
            color: 'webTypo.textPrimary'
        },
        headerRow: {
            flex: '1',
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        headerTitleRow: {
            alignItems: 'center',
            textStyle: 'webH3'
        },
        headerAmount: {
            textStyle: 'bodySmBold',
        },
        accordionPanel: {
            px: 0,
            mb: 4
        },
        detailsStack: {
            w: 'full',
            gap: 1
        },
        detailsRow: {
            justify: 'space-between'
        },
        shippingLabelWrap: {
            alignItems: 'center'
        },
        shippingLabel: {
            lineHeight: 1,
            fontSize: 'sm'
        },
        totalRow: {
            w: 'full',
            justify: 'space-between',
            mt: '16px'
        },
        totalText: {
            fontWeight: 'bold',
            fontSize: 'sm',
            textTransform: 'uppercase'
        },
        taxShippingAtCheckout: {
            color: 'webTypo.textSecondary',
            textStyle: 'bodySmRegular',
            textAlign: 'left',
            textTransform: 'none'
        }
    }
}
